import { mapGetters, mapMutations } from 'vuex';
import clientService from './../../../../services/client';
import organizationMemberBookingService from './../../../../services/organizationMemberBooking';
import Moment from 'moment';

export default {
  props: {
    date: {
      required: true,
      type: Date,
    },

    action: {
      required: true,
      type: String,
      default: 'ADD',
    },

    event: {
      type: [Object, Array],
      default: () => {},
    },

    onStore: {
      type: Function,
      default: () => {},
    },

    onUpdate: {
      type: Function,
      default: () => {},
    },
  },

  data: () => ({
    newBookingForm: {
      id: '',
      product_id: '',
      member_id: '',
      client_id: '',
      date: '',
      start_time: '',
      end_time: '',
      order_id: '',
      order_number: '',
    },
    newBookingRules: {
      product_id: [
        { required: true, trigger: 'blur' },
      ],
      client_id: [
        { required: true, trigger: 'blur' },
      ],
    },
  }),

  computed: {
    ...mapGetters({
      clients: 'allClients',
      account: 'account',
      organization_members: 'allOrganizationMembers',
    }),

    memberProducts() {
      var member_products = [];

      for (var om of this.organization_members){
        om.organizationMemberProducts.forEach(function(omp) {
          if (member_products.findIndex(x => x.product_id == omp.product_id) == -1) {
            member_products.push(omp);
          }
        });
      };

      return member_products;
    },

    productMembers() {
      var organization = {
        id: '',
        user: {
          full_name: this.account.firstName + ' ' + this.account.lastName + ' (Organization)'
        }
      };
      var product_members = [organization];

      if (this.newBookingForm.product_id) {
        var $this = this;
        for (var om of this.organization_members){
          if (om.organizationMemberProducts.findIndex(x => x.product_id == $this.newBookingForm.product_id) > -1) {
            product_members.push(om);
          }
        };
      }


      return product_members;
    },
  },

  created() {
    console.log(this.event);
    clientService.all();
    this.newBookingForm.date =  Moment(this.date).format('YYYY-MM-DD');
    if (this.action == 'ADD') {
      this.newBookingForm.start_time = Moment(this.date).format('HH:mm');
    } else if (this.action == 'EDIT' && this.event) {
      this.newBookingForm.id = this.event.id;
      this.newBookingForm.product_id = this.event.product_id;
      this.newBookingForm.member_id = this.event.member_id;
      this.newBookingForm.client_id = this.event.client_id;
      this.newBookingForm.start_time = this.event.start_time;
      this.newBookingForm.end_time = this.event.end_time;
      this.newBookingForm.order_id = this.event.order_id;
      this.newBookingForm.order_number = this.event.order_number;
      this.newBookingForm.order_status =this.event.order_status;

    }
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    updateEndTime() {
      if (this.newBookingForm.product_id) {
        var member_product = this.memberProducts.find(x => x.product_id == this.newBookingForm.product_id);
        if (member_product) {
          this.newBookingForm.end_time = Moment(this.newBookingForm.start_time, 'H:mm').add(member_product.product.product_configuration.duration, 'minutes').format('HH:mm');
        }
      }
    },

    store() {
      this.$refs['newBookingForm'].validate(async(valid) => {
        if (valid) {
          var loading = this.$loading({
            target: '.el-dialog'
          });
          if (this.action == 'ADD') {
            var response = await organizationMemberBookingService.store(this.newBookingForm)
              .catch((error) => {
                this.$message({
                  message: error,
                  type: 'error',
                });
              });

          } else if (this.action == 'EDIT') {
            var response = await organizationMemberBookingService.update(this.newBookingForm)
            .catch(error => {
              this.$message({
                message: error,
                type: 'error',
              });
            });
          }

          loading.close();

          if (response)
          {
            var event = {
              id: response.id,
              product_id: response.order.order_products.length > 0 ? response.order.order_products[0].product_id : '',
              member_id: response.organization_member_product ? response.organization_member_product.organization_member_id : '',
              client_id: response.order.client_id,
              data_date: response.date,
              start_time: response.start_time,
              end_time: response.end_time,
              order_id: response.order.id,
              order_number: response.order.number,
              title: response.order.client.name || response.order.client.client_contact.email,
              productName: response.order.order_products.length > 0 ? response.order.order_products[0].name : '',
              memberName: response.organization_member_product ? response.organization_member_product.organization_member.user.full_name : response.order.organization.name,
              start: response.date + ' ' + response.start_time,
              end: response.date + ' ' + response.end_time,
              backgroundColor: response.organization_member_product ? response.organization_member_product.organization_member.color : '#777777',
              borderColor: response.organization_member_product ? response.organization_member_product.organization_member.color : '#777777',
            };

            if (this.action == 'ADD') {
              this.onStore(event);
            } else if (this.action == 'EDIT') {
              this.onUpdate(event);
            }

            this.closeModal();
          }
        }
      });
    },

    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },

    formatDate(date) {
      if (!date) return '';
      return Moment(date).format('MMM DD, YYYY');
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/booking/create/create.js